export default __webpack_public_path__ + "static/media/personal@2x.0e379f10.png";